/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
  // 6LexgMgZAAAAAGb8_nPKJHZI1CWrFvKvzE8G8VT8
  // 6LexgMgZAAAAAGVs83-UYmiPSDIs2Y4zCqf1Xin-
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    apiUrl: window["env"]["apiUrl"] || "http://150.95.110.131:8085/api",
    mqttUrl: window["env"]["mqttUrl"] || "mqtt://150.95.104.49:8083",
    captcha_siteKey: '6LerXI8qAAAAAIs-SS8TOf3j4nPHl7AJB0UhIhSY',
    login_captcha: false
  };